import Image from 'next/image';
import { ReactElement, SVGProps } from "react";

import { Icons } from "@/components/icons";
import { WalletType, WalletTypeExtended } from "@/context/types";

export const Wallets: {
  [K in WalletType]: {
    label: string;
    logo: ReactElement<SVGProps<SVGSVGElement>>;
    downloadLink: string;
  };
} = {
  [WalletType.Xverse]: {
    label: "Xverse",
    logo: <Icons.xverse className="size-10" />,
    downloadLink: "https://www.xverse.app/download",
  },
  [WalletType.Unisat]: {
    label: "Unisat",
    logo: <Icons.unisat className="size-10" />,
    downloadLink: "https://unisat.io/download",
  },
};

export const WalletsExtended: {
  [K in WalletTypeExtended]: {
    label: string;
    logo: ReactElement<SVGProps<SVGSVGElement>>;
    downloadLink: string;
  };
} = {
  [WalletTypeExtended.Xverse]: {
    ...Wallets[WalletType.Xverse],
    logo: <Icons.xverse className="size-6" />,
  },
  [WalletTypeExtended.Unisat]: {
    label: "Unisat",
    logo: <Icons.unisat className="size-6" />,
    downloadLink: "https://unisat.io/download",
  },
  [WalletTypeExtended.Leather]: {
    label: "Leather",
    logo: <Icons.leather className="size-6" />,
    // downloadLink: "https://leather.io/install-extension",
    downloadLink: "https://leather.io/wallet/extension",
  },
  [WalletTypeExtended.Metamask]: {
    label: "Metamask",
    logo: <Image src="/assets/wallets/metamask.png" className="size-6" alt="Metamask" width={24} height={24} />,
    downloadLink: "https://metamask.io/download",
  },
  // [WalletTypeExtended.MagicEden]: {
  //   label: "ME",
  //   logo: <Image src="/assets/wallets/magiceden.avif" className="size-6" alt="ME" width={24} height={24} />,
  //   downloadLink: "https://wallet.magiceden.io/download",
  // },
};
